import { render, staticRenderFns } from "./Awardreview.vue?vue&type=template&id=9fe194e6&scoped=true"
import script from "./Awardreview.vue?vue&type=script&lang=js"
export * from "./Awardreview.vue?vue&type=script&lang=js"
import style1 from "./Awardreview.vue?vue&type=style&index=1&id=9fe194e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe194e6",
  null
  
)

export default component.exports